import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
//services
import { AesService } from 'src/app/core/services/utils/aes.service';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { EmitService } from './../../../../core/services/utils/emit.service';
import { LocalService } from './../../../../core/services/storage/local.service';
import { EstadosService } from './../../../../core/services/http/estados.service';
// import { CustomerService } from 'src/app/core/services/customer/customer.service';
import { SweetAlertService } from 'src/app/core/services/utils/sweet-alert.service';
import { RutService } from 'src/app/core/services/utils/rut.service';
import { FormatoRutService } from 'src/app/core/services/utils/formato-rut.service';
import { API_ENDPOINT } from 'src/app/core/services/config/config';
import { TurnosService } from 'src/app/core/services/http/turnos.service';

import { environment } from 'src/environments/environment';
import { log } from 'console';

@Component({
  selector: 'app-modal-datos-usuario',
  templateUrl: './modal-datos-usuario.component.html',
  styleUrls: ['./modal-datos-usuario.component.css']
})
export class ModalDatosUsuarioComponent implements OnInit, OnDestroy {
  turno: any;
  escritorio: any;
  form: FormGroup = new FormGroup([]);
  emiStatus: any;
  formIsSubmitted = false;
  validatedRut = false;
  numTurno: any;
  //CONFIG CLIENTE
  frontsSubscription: Subscription = new Subscription();
  // fronts: any = this.customerService.fronts.value;
  customerSettings:any;
  parametrosCustomer:any;
  rutRequerido: boolean = true;
  rutValue:any = '';
  clienteValue:any = '';
  public event: EventEmitter<any> = new EventEmitter();
  modo: any = {};
  fonoCliente: any;

  constructor(
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private localSecureService: LocalService,
    // private customerService: CustomerService,
    private sweetAlertService: SweetAlertService,
    private rutService: RutService,
    private turnosService: TurnosService,
    private formatoRutService: FormatoRutService
  ) {
    // this.frontsSubscription = this.customerService.fronts.subscribe(fronts => this.fronts = fronts);
  }

  ngOnInit(): void {
    this.escritorio = this.localSecureService.getValue('escritorio');
    this.customerSettings = this.localSecureService.getValue('customer');
    this.parametrosCustomer = this.localSecureService.getValue('parametros');
    this.modo = this.parametrosCustomer.solicitarDatos;
    if(!this.modo) { this.cerrar(); return; }
    
    this.rutValue = this.turno.rut;
    this.clienteValue = this.turno.cliente;
    this.fonoCliente = this.turno.fono;

    if(this.rutValue == 'No disponible'){
      this.rutValue = null
    }

    if(this.clienteValue == 'No disponible') {
      this.clienteValue = '';
    }

    if(this.fonoCliente == 'No disponible') {
      this.fonoCliente = '';
    }

    // this.rutRequerido = this.rutValue ? this.rutValue?.includes('-') : true;
    this.setForm();
    this.formatRut();
  }

  setForm() {
    if(this.modo.rut) {
      this.form.addControl('rut', new FormControl(this.rutValue, [Validators.required]));
    }

    if(this.modo.nombre) {
      this.form.addControl('nombreCliente', new FormControl(this.clienteValue + "", [Validators.required]));
    }

    if (this.modo.telefono) {
        this.form.addControl('fono', new FormControl(this.fonoCliente, [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(10),
          Validators.pattern(/^[a-zA-Z0-9]*$/)
    ]));
    }
  }
  validateInput(event: KeyboardEvent): void {
    const allowedChars = /^[a-zA-Z0-9]*$/; 
    const inputChar = event.key;

    if (!allowedChars.test(inputChar)) {
        event.preventDefault();
    }
}

  setRut() {
    this.formatRut();
  }
  async formatRut() {
    const valor = this.form.value.rut;
    this.form.patchValue({
      rut: valor
    });
    if(this.form.value.rut) {
        this.validatedRut = this.validateRut();
        this.form.patchValue({
          rut: this.formatoRutService.formatearRut(this.form.value.rut),
        });
    }
  }
  private validateRut() {
    const userRut = this.limpiarRut();
    return this.rutService.validarRut(userRut);
  }
  validateDNI(): boolean {
    let dni = this.form.value.rut.replace(/\./g, '').replace('-', '');
    let dniRegex = /^\d{1,10}$/;
    return dniRegex.test(dni);
  }
  private limpiarRut() {
    if(this.form.value.rut) {
      return this.form.value?.rut.replace(/\./g, '').replace('-', '');
    } else {
      return '';
    }
  }

  onSubmit(){
    this.formIsSubmitted = true;
    if(this.modo.rut){
      if(this.rutRequerido){
        this.validatedRut = this.validateRut();
        if (this.form.invalid || !this.validatedRut) { return }
      } else {
        this.validatedRut = this.validateDNI();
        if (this.form.invalid || !this.validatedRut) { return }
      }

      this.datosUsuario();      
    } else {
      if (this.form.invalid) { return }
      this.datosUsuario();      
    }
  }

  async datosUsuario() {
    this.formIsSubmitted = true;
    this.sweetAlertService.swalLoading();
    try{
      const rut = this.modo.rut ? this.form.get('rut')?.value : this.turno.rut;
      const cliente = this.modo.nombre ? this.form.get('nombreCliente')?.value : this.turno.cliente;
      const fono = this.modo.telefono ? this.form.get('fono')?.value.toUpperCase() : this.turno.fono
      const turno = {
        "idTurno": this.turno.idTurno,
        "rut": rut !== "No disponible" ? rut.replace(/\./g, '') : '',
        "cliente": cliente !== 'No disponible' ? cliente : '',
        "fono":  fono,
      }
      const resp: any =  await this.turnosService.setDataById(turno);
      this.sweetAlertService.swalClose();
      if(!resp.status) {
        this.closeModal();
        return;
      }

      this.closeModal({
        "rut":  rut !== "No disponible" ? rut.replace(/\./g, '') : '',
        "cliente": cliente !== 'No disponible' ? cliente : '',
        "fono":  fono,
      });
    } catch(e){
      this.sweetAlertService.swalClose();
      this.closeModal();
    }
  }

  cerrar(){
    this.closeModal();
  }

  closeModal(data:any = false): void {
    this.event.emit(data);
    this.modalService.closeModal(); 
  }

  ngOnDestroy(): void {
    this.frontsSubscription.unsubscribe();
  }
}
